module.exports = __webpack_public_path__ + "img/csat.75ad33d3.png";